import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/index.css'

import echartsGL from 'echarts-gl'

// 原计算字体大小使用rem的自适应方案
// import './utils/flexible.js'

// 轮播图组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import css from 'swiper/css/swiper.min.css'
// vuex
import store from './store'
// 部分引入Element
import { Message,Form,FormItem,Cascader,Checkbox,CheckboxGroup,Button,Table,TableColumn,Loading,Select,Option,Container,Header,Main,Aside,DatePicker,Dialog,Progress,Collapse, CollapseItem,Radio, } from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Loading)
Vue.use(Loading.directive)
Vue.use(Select);
Vue.use(Option);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Aside);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Progress);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.prototype.$message = Message
// import { Message } from 'element-ui';
export default () => {
  Vue.use(VueAwesomeSwiper, {
    css
  })
}
// eltable自适应组件
import Plugin from 'v-fit-columns';
Vue.use(Plugin);

// import Echarts from 'echarts'
Vue.config.productionTip = false

// Vue.prototype.$echarts = Echarts

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
